import { useEffect, useRef, useState } from "react";
import { ChevronDown } from "lucide-react";
import { AREA_FIELDS } from "./LocTypeFields";

const fmt = (n) => (n || 0).toLocaleString("tr-TR", { maximumFractionDigits: 2 });
const num = (v) => parseFloat(String(v ?? "").replace(",", ".")) || 0;

// Şube listesi m² hücresi: dağılım varsa tıklanınca küçük açılır özet (etiket · m²) + toplam; ESC / dışarı tıklama kapatır
export default function M2Cell({ l, sel }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const items = AREA_FIELDS.map(([k, label]) => ({ k, label, v: num((l.area_m2 || {})[k]) })).filter((x) => x.v > 0);
  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => { if (!ref.current?.contains(e.target)) setOpen(false); };
    const onKey = (e) => { if (e.key === "Escape") { e.stopPropagation(); setOpen(false); } };
    document.addEventListener("mousedown", onDoc); window.addEventListener("keydown", onKey, true);
    return () => { document.removeEventListener("mousedown", onDoc); window.removeEventListener("keydown", onKey, true); };
  }, [open]);
  if (!l.branch_m2) return <span>—</span>;
  const text = `${fmt(l.branch_m2)} m²`;
  if (!items.length) return <span>{text}</span>;
  const total = items.reduce((s, x) => s + x.v, 0);
  return (
    <span ref={ref} className="relative inline-block" onClick={(e) => e.stopPropagation()} data-esc-trap={open || undefined}>
      <button type="button" onClick={() => setOpen((v) => !v)} aria-expanded={open} data-testid={`loc-m2-toggle-${l.id}`} title="m² dağılımını göster"
        className={`inline-flex items-center gap-1 rounded px-1 -mx-1 underline decoration-dotted underline-offset-2 ${sel ? "hover:bg-white/20" : "hover:bg-amber-50 text-slate-900"}`}>
        {text} <ChevronDown className={`w-3 h-3 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute right-0 top-full z-30 mt-1 w-60 rounded-md border border-slate-300 bg-white text-slate-800 shadow-xl p-2 text-left font-normal" data-testid={`loc-m2-popover-${l.id}`}>
          <div className="text-[10px] font-semibold uppercase tracking-wider text-slate-500 mb-1">m² Dağılımı · {items.length} alan</div>
          <ul className="divide-y divide-slate-100 max-h-56 overflow-y-auto">
            {items.map((x) => <li key={x.k} className="flex items-center justify-between gap-2 py-0.5 text-xs"><span className={x.k === "genel_temizlik" ? "font-semibold text-emerald-700" : ""}>{x.label}</span><span className="font-mono tabular-nums">{fmt(x.v)} m²</span></li>)}
          </ul>
          <div className="flex items-center justify-between border-t border-slate-200 mt-1 pt-1 text-xs font-bold"><span>Toplam</span><span className="font-mono tabular-nums" data-testid={`loc-m2-popover-total-${l.id}`}>{fmt(total)} m²</span></div>
          {(l.floor_count_total != null || l.floor_count_used != null) && <div className="flex items-center justify-between text-[11px] text-slate-600 pt-0.5" data-testid={`loc-m2-popover-floors-${l.id}`}><span>Kat (kullanılan / toplam)</span><span className="font-mono tabular-nums">{l.floor_count_used ?? "—"} / {l.floor_count_total ?? "—"}</span></div>}
        </div>
      )}
    </span>
  );
}
